import React, { FC, useState } from 'react'
import { translate } from '../../../core'
import { Button, Checkbox, Col, Form, Modal, Row, Space } from 'antd'
import { InventoryByManufactureRequest, ItemType } from '../type'
import { Combo, StimulsoftViewer } from '../../../core/component'
import { getItemTypeComboOptions } from '../func/type-options'
import { showItemOptionsMapper, ShowItemOptionsSelect } from '../func/showItemOptionsList'
import { ItemShowOptions } from '../type/item-query'
import { VendorSelect } from '../../contact/component/VendorSelect'

type InventoryByManufactureForm = Omit<InventoryByManufactureRequest, 'archived'> & {
  status: ItemShowOptions
}

export const InventoryByManufactureReport: FC = () => {
  const [form] = Form.useForm<InventoryByManufactureForm>()
  const [request, setRequest] = useState<InventoryByManufactureRequest>()
  const [confirmModalVisible, setConfirmModalVisible] = useState(false)

  const isFormValid = async (): Promise<boolean> => {
    try {
      await form.validateFields({validateOnly: true})
      return true
    } catch {
      return false
    }
  }

  const handleOK = async () => {
    if (await isFormValid()) {
      setConfirmModalVisible(false)
    }
    form.submit()
  }

  return (
    <>
      <Button
        type='primary'
        onClick={() => setConfirmModalVisible(true)}
        className='btn-primary-gradient'
      >
        {translate('new_report')}
      </Button>

      <StimulsoftViewer
        name='inventory-by-manufacture'
        request={request}
        skip={!request}
      />

      <Modal
        open={confirmModalVisible}
        onCancel={() => setConfirmModalVisible(false)}
        onOk={handleOK}
        okText={translate('get_report')}
        cancelText={translate('cancel')}
        width={670}
        footer={<Space>
          <Button
            onClick={() => setConfirmModalVisible(false)}
          >
            {translate('cancel')}
          </Button>

          <Button
            onClick={() => form.resetFields()}
          >
            {translate('clear')}
          </Button>

          <Button
            type='primary'
            onClick={handleOK}
          >
            {translate('get_report')}
          </Button>

        </Space>}
      >
        <Form
          initialValues={{inStock: true, status: ItemShowOptions.NoneArchived}}
          layout='vertical'
          form={form}
          onFinish={data => {
            setRequest({
              ...data,
              archived: showItemOptionsMapper[data.status ?? ItemShowOptions.All].value,
            })
          }}
          className='d-flex flex-column gap-2 mt-4'
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item name='type' label={translate('type')}>
                <Combo<any, ItemType>
                  allowMultiple
                  size='middle'
                  options={getItemTypeComboOptions()}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name='vendorId'
                label={translate('manufacture', 'or', 'vendor')}
              >
                <VendorSelect
                  mode='multiple'
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                name='status'
                label={translate('status')}
              >
                <ShowItemOptionsSelect/>
              </Form.Item>
            </Col>

            <Col span={12} className='d-flex align-items-center'>
              <Form.Item
                name='inStock'
                valuePropName='checked'
              >
                <Checkbox>{translate('in_stock_only')}</Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}
